import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { LocalTranslation } from "../../../../constants/translations";
import { RecordingStatus } from "../..";
import styles from "./index.module";
import { setLocalStorageAuthorisationToRecord } from "../../hooks";
import { SessionReplayEventButton, SessionReplayEventSection } from "../../../../constants";
import useGeneralConfigs from "../../../../hooks/useGeneralConfigs";
const AuthorisationMessage = (props) => {
  const { setRecordingStatus, customAuthorisationComponent: CustomAuthorisationComponent, uid } = props;
  const { userLang, teaCollectEvent } = useGeneralConfigs();
  useEffect(() => {
    teaCollectEvent == null ? void 0 : teaCollectEvent("section_show", {
      section: SessionReplayEventSection.USER_RESEARCH_AUTHORISE_POPUP
    });
  }, []);
  const onAuthorise = () => {
    teaCollectEvent == null ? void 0 : teaCollectEvent("button_click", {
      click_for: SessionReplayEventButton.USER_RESEARCH_AUTHORISE_REPLAY
    });
    setLocalStorageAuthorisationToRecord(true, uid);
    setRecordingStatus(RecordingStatus.AUTHORISED_TO_RECORD);
  };
  const onExit = () => {
    teaCollectEvent == null ? void 0 : teaCollectEvent("button_click", {
      click_for: SessionReplayEventButton.USER_RESEARCH_NO_AUTH_REPLAY
    });
    setLocalStorageAuthorisationToRecord(false, uid);
    setRecordingStatus(RecordingStatus.NO_AUTHORISATION);
  };
  const authorisationTitle = LocalTranslation.UserResearchAuthorisationTitle[userLang];
  const authorisationMessage = LocalTranslation.UserResearchAuthorisationMessage[userLang].split("\n").map((item, i) => /* @__PURE__ */ jsx("p", { children: item ? item : /* @__PURE__ */ jsx("br", {}) }, i));
  const authoriseButtonText = LocalTranslation.AcceptAuthorisation[userLang];
  const refuseAuthorisationButtonText = LocalTranslation.DeclineAuthorisation[userLang];
  if (CustomAuthorisationComponent) {
    return /* @__PURE__ */ jsx(
      CustomAuthorisationComponent,
      {
        authorisationTitle,
        authorisationMessageContent: authorisationMessage,
        authoriseButtonText,
        exitButtonText: refuseAuthorisationButtonText,
        onAuthorise,
        onExit
      }
    );
  }
  return /* @__PURE__ */ jsx("div", { className: styles.banner, children: /* @__PURE__ */ jsxs("div", { className: styles.modal, children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("div", { className: styles.modalTitle, children: authorisationTitle }),
      /* @__PURE__ */ jsx("div", { className: styles.modalText, children: authorisationMessage })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles.buttonRow, children: [
      /* @__PURE__ */ jsx("button", { onClick: onExit, className: styles.secButton, children: refuseAuthorisationButtonText }),
      /* @__PURE__ */ jsx("button", { onClick: onAuthorise, className: styles.priButton, children: authoriseButtonText })
    ] })
  ] }) });
};
var authorisation_message_default = AuthorisationMessage;
export {
  AuthorisationMessage,
  authorisation_message_default as default
};
